import { Link } from 'react-router-dom';
import styles from './footer.module.scss';

export function Footer() {

    //const { t } = useTranslation();
    //const navigate = useNavigate();

    return (
        <footer className={styles.bFooter}>
            <div className={styles.bFooterGrid}>

                <div style={{ textAlign: "center" }}><Link className={styles.ba} to={"/kontakt"}>Kontakt</Link></div>
                <div style={{ textAlign: "center" }}><Link className={styles.ba} to={"/impressum"}>Impressum</Link></div>
                <div style={{ textAlign: "center" }}>
                    Kundenzugang: <a className={styles.ba} href="https://app.bergamotti.de">app.bergamotti.de</a>
                </div>

            </div>
        </footer>
    );
}

export default Footer;
